(() => {
  const state = window.__rkGlassesPage || {};
  const pageActiveClass = 'rk-glasses-page-active';
  const headerCollapsedClass = 'rk-glasses-header-collapsed';
  const productNavVisibleClass = 'rk-glasses-product-nav-visible';

  const getSiteHeader = () => (
    document.getElementById('shopify-section-header-v2')
    || document.querySelector('.shopify-section-header')
  );

  const getAnnouncementBar = () => document.getElementById('shopify-section-announcement-bar');

  const getOffset = (target) => {
    const siteHeader = getSiteHeader();
    const productNav = document.querySelector('[data-rk-glasses-nav]');
    const headerIsCollapsed = document.documentElement.classList.contains(headerCollapsedClass);
    const targetTop = target ? target.getBoundingClientRect().top + window.scrollY : 0;
    const headerWillBeCollapsed = Number.isFinite(state.navActivationY) && targetTop >= state.navActivationY;
    const siteHeaderHeight = siteHeader && !headerIsCollapsed && !headerWillBeCollapsed
      ? siteHeader.getBoundingClientRect().height
      : 0;
    const productNavHeight = productNav ? productNav.getBoundingClientRect().height : 0;
    return siteHeaderHeight + productNavHeight + 12;
  };

  const setupHeaderScroll = () => {
    if (state.headerScrollHandler) window.removeEventListener('scroll', state.headerScrollHandler);
    if (state.headerResizeHandler) window.removeEventListener('resize', state.headerResizeHandler);
    if (state.headerResizeObserver) state.headerResizeObserver.disconnect();

    const documentElement = document.documentElement;
    const productNav = document.querySelector('[data-rk-glasses-nav]');
    const navSection = productNav ? productNav.closest('.shopify-section') : null;
    const siteHeader = getSiteHeader();
    const announcementBar = getAnnouncementBar();

    if (!productNav || !navSection) {
      documentElement.classList.remove(pageActiveClass, headerCollapsedClass, productNavVisibleClass);
      return;
    }

    documentElement.classList.add(pageActiveClass);
    navSection.classList.add('rk-glasses-nav-section');

    const measure = () => {
      state.siteHeaderHeight = siteHeader ? siteHeader.getBoundingClientRect().height : 0;
      state.announcementHeight = announcementBar ? announcementBar.getBoundingClientRect().height : 0;
      state.navActivationY = Math.max(0, state.announcementHeight + state.siteHeaderHeight);
    };

    const update = () => {
      const shouldShowProductNav = window.scrollY > state.navActivationY;
      documentElement.classList.toggle(headerCollapsedClass, shouldShowProductNav);
      documentElement.classList.toggle(productNavVisibleClass, shouldShowProductNav);
      productNav.toggleAttribute('inert', !shouldShowProductNav);
      productNav.setAttribute('aria-hidden', shouldShowProductNav ? 'false' : 'true');
    };

    state.headerScrollHandler = () => {
      if (state.headerScrollFrame) return;
      state.headerScrollFrame = window.requestAnimationFrame(() => {
        state.headerScrollFrame = null;
        update();
      });
    };

    state.headerResizeHandler = () => {
      measure();
      update();
    };

    window.addEventListener('scroll', state.headerScrollHandler, { passive: true });
    window.addEventListener('resize', state.headerResizeHandler, { passive: true });
    if ('ResizeObserver' in window) {
      state.headerResizeObserver = new ResizeObserver(() => {
        measure();
        update();
      });
      if (siteHeader) state.headerResizeObserver.observe(siteHeader);
      if (announcementBar) state.headerResizeObserver.observe(announcementBar);
    }
    measure();
    update();
  };

  const handleAnchorClick = (event) => {
    const link = event.target.closest('.rk-glasses-v3 a[data-rk-anchor]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.id === 'rk-top'
      ? 0
      : target.getBoundingClientRect().top + window.scrollY - getOffset(target);
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  const handleGalleryControlClick = (event) => {
    const control = event.target.closest('[data-rk-ai-gallery-direction]');
    if (!control) return;

    const gallery = control.closest('[data-rk-ai-gallery]');
    const track = gallery ? gallery.querySelector('[data-rk-ai-gallery-track]') : null;
    const slides = track ? [...track.children] : [];
    if (!track || slides.length < 2) return;

    const slideWidth = track.clientWidth;
    const currentIndex = Math.round(track.scrollLeft / Math.max(slideWidth, 1));
    const step = control.dataset.rkAiGalleryDirection === 'previous' ? -1 : 1;
    const nextIndex = (currentIndex + step + slides.length) % slides.length;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    track.scrollTo({
      left: nextIndex * slideWidth,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };

  const resetDesktopGalleryScroll = () => {
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    document.querySelectorAll('[data-rk-ai-gallery-track]').forEach((track) => {
      if (track.scrollLeft !== 0) track.scrollLeft = 0;
    });
  };

  const refreshObserver = () => {
    if (state.observer) state.observer.disconnect();
    if (!('IntersectionObserver' in window)) return;

    const productLinks = [...document.querySelectorAll('[data-rk-glasses-nav] [data-rk-nav-link]')];
    const functionSections = [...document.querySelectorAll('[data-rk-function]')];
    const visibleFunctionSections = new Set();

    state.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visibleFunctionSections.add(entry.target);
        else visibleFunctionSections.delete(entry.target);
      });

      productLinks.forEach((link) => link.removeAttribute('aria-current'));

      const activeSection = functionSections.find((section) => visibleFunctionSections.has(section));
      if (!activeSection) return;

      const key = activeSection.dataset.rkFunction;
      const activeProductLink = productLinks.find((link) => link.getAttribute('href') === `#${key}`);

      if (activeProductLink) activeProductLink.setAttribute('aria-current', 'true');
    }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 });

    functionSections.forEach((section) => state.observer.observe(section));
  };

  if (!state.clickBound) {
    document.addEventListener('click', handleAnchorClick);
    state.clickBound = true;
  }

  if (!state.galleryClickBound) {
    document.addEventListener('click', handleGalleryControlClick);
    state.galleryClickBound = true;
  }

  if (!state.galleryResizeBound) {
    state.galleryResizeHandler = () => {
      if (state.galleryResizeFrame) return;
      state.galleryResizeFrame = window.requestAnimationFrame(() => {
        state.galleryResizeFrame = null;
        resetDesktopGalleryScroll();
      });
    };
    window.addEventListener('resize', state.galleryResizeHandler, { passive: true });
    state.galleryResizeBound = true;
  }

  if (!state.editorBound) {
    document.addEventListener('shopify:section:load', refreshObserver);
    document.addEventListener('shopify:section:unload', refreshObserver);
    document.addEventListener('shopify:section:reorder', refreshObserver);
    state.editorBound = true;
  }

  if (!state.headerEditorBound) {
    document.addEventListener('shopify:section:load', setupHeaderScroll);
    document.addEventListener('shopify:section:unload', setupHeaderScroll);
    document.addEventListener('shopify:section:reorder', setupHeaderScroll);
    state.headerEditorBound = true;
  }

  window.__rkGlassesPage = state;
  refreshObserver();
  setupHeaderScroll();
  resetDesktopGalleryScroll();
})();
